function WarningIcon() {
  return (
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10" r="7" fill="#CB2B2B"/>
            <path d="M11.3997 9.25415L11.0637 11.1067H9.93188L9.59692 9.25122V6.15942L11.4016 6.15552L11.3997 9.25415Z"
                  fill="#FCFAF8" stroke="#FCFAF8" strokeWidth="0.711898"/>
            <path d="M11.0872 13.3704V14.5442H9.91138V13.3704H11.0872Z" fill="#FCFAF8" stroke="#FCFAF8"
                  strokeWidth="0.711898"/>
        </svg>
  );
}

export default WarningIcon;
